import omit from 'lodash/omit';

import apiService from './apiService';
import * as ACTION from './constants';
import { processApiRequest } from './../Common/saga';

export function* getSuggestOrders(action) {
    yield processApiRequest(ACTION.GET_SUGGEST_ORDERS, () => apiService.suggest(omit(action.payload, 'callback')), action.payload);
}
